module.exports = __webpack_public_path__ + "static/media/wellnite-auth-hero_430.7f5a9aa0.webp";